import { useEffect, useState } from 'react';
import { filterCategoriesByGroupAndFacility, filterGeneralInformationOptionsByGroup } from '../utils/button-selection-utils';
import {
    originalCategories,
    generalInformationOptions,
    conversionFactors
} from '../constants/button-selection-constants';

export default function useButtonSelection(variant, company, years, groups) {
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [selectedGroup, setSelectedGroup] = useState(null)
    const [selectedFacility, setSelectedFacility] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedDataCapturingCategory, setSelectedDataCapturingCategory] = useState(null)
    const [selectedGeneralInformationOption, setSelectedGeneralInformationOption] = useState(null)
    const [selectedConversionFactor, setSelectedConversionFactor] = useState(null)

    const filteredCategories = originalCategories.map((categoryItem) => {
        const filteredCategories = filterCategoriesByGroupAndFacility(categoryItem.categories, selectedGroup?.name, selectedFacility?.name)
        return { name: categoryItem.name, categories: filteredCategories }
    })

    const filteredGeneralInformationOptions = filterGeneralInformationOptionsByGroup(generalInformationOptions, selectedGroup)

    const facilities = selectedGroup?.facilities

    const handleOnClick = (clickedButton) => {
        if (years?.includes(clickedButton)) {
            setSelectedYear(clickedButton);
            setSelectedCompany(company);
            // Reset state of buttons when top level button is clicked
            setSelectedGroup(null);
            setSelectedFacility(null);
            setSelectedCategory(null);
            setSelectedDataCapturingCategory(null);
            setSelectedGeneralInformationOption(null);
            setSelectedConversionFactor(null);
        }
        else if (clickedButton.facilities &&
            groups?.some((group) => (clickedButton.id === group.id && group.facilities))) {
            setSelectedGroup(clickedButton);
            setSelectedFacility(null);
            setSelectedCategory(null);
            setSelectedDataCapturingCategory(null);
            setSelectedGeneralInformationOption(null);
        }
        else if (facilities?.some((facility) => (clickedButton.id === facility.id))) {
            setSelectedFacility(clickedButton);
            setSelectedCategory(null);
            setSelectedDataCapturingCategory(null);
            setSelectedGeneralInformationOption(null);
        }
        else if (filteredCategories?.some((category) => (clickedButton.name === category.name))) {
            setSelectedCategory(clickedButton);
            if (variant === 'data-capturing') {
                setSelectedDataCapturingCategory(clickedButton.categories[0]);
            }
        }
        else if (filteredCategories?.some((categoryObject) => (categoryObject.categories.includes(clickedButton)))) {
            setSelectedDataCapturingCategory(clickedButton);
        }
        else if (generalInformationOptions.includes(clickedButton)) {
            setSelectedGeneralInformationOption(clickedButton);
        }
        else if (conversionFactors.includes(clickedButton)) {
            setSelectedConversionFactor(clickedButton);
        }
    }

    useEffect(() => {
        setSelectedYear(null)
        setSelectedCompany(null)
        setSelectedGroup(null)
        setSelectedFacility(null)
        setSelectedCategory(null)
        setSelectedDataCapturingCategory(null)
        setSelectedGeneralInformationOption(null)
        setSelectedConversionFactor(null)
    }, [])

    useEffect(() => {
        setSelectedCategory(null)
    }, [selectedConversionFactor])

    return {
        selectedYear,
        selectedCompany,
        selectedGroup,
        selectedFacility,
        selectedCategory,
        selectedDataCapturingCategory,
        selectedGeneralInformationOption,
        selectedConversionFactor,
        categories: filteredCategories,
        generalInformationOptions: filteredGeneralInformationOptions,
        handleOnClick,
    }
}